class DocumentationScroll{
    constructor(){
        this.currentReadingDocument = null;
        this.manageItemsScroll = null;
        this.autoPlayDoc = true;
        this.updateLastRead = null;
        this.lastScrollPosition = null;
    }

    startPathScrollManagement(startReadingScroll) {
        const wrapperPath = $(window).width() >= 1280 ? '.wrapper-desktop-path' : '.wrapper-path';
        const elements = document.querySelectorAll(`${wrapperPath} .documentation-advanced-documents-row`);

        const handleIntersection = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.markAsReadingPathItem($(entry.target));
                } else {
                    this.stopCurrentReadingPathItem($(entry.target));
                }
            });
        };

        const ioOptions = {
            threshold: 1,
            rootMargin: "16px"
        };

        const observer = new IntersectionObserver(handleIntersection, ioOptions);

        elements.forEach((element) => {
            observer.observe(element);
        });
    }

    stopCurrentReadingPathItem(listItem) {
        if (!listItem) {
            return;
        }

        const docId = parseInt(listItem.data("resource") ? listItem.data("resource") : listItem.data("document"));
        const documentType = listItem.data('type');

        const documentationPathUtils = documentationScreenController.documentationPath.getPathUtils();
        const currentDocument = documentationPathUtils.getSectionItem(docId);

        if (currentDocument.completed && currentDocument.progressState === 'COMPLETED') {
            return;
        }

        if (DocumentationUtils.isAutomaticReadingDocument(documentType)) {
            documentationScreenController.documentationProgress.stopRead(docId);
            this.currentReadingDocument = null;
        }

        if (['AUDIO', 'VIDEO'].indexOf(documentType) >= 0) {
            pauseMedia(listItem.find(documentType)[0]);
        }
    }

    markAsReadingPathItem(listItem) {
        if (!listItem) {
            return;
        }

        const documentationPathUtils = documentationScreenController.documentationPath.getPathUtils();
        const documentId = parseInt(listItem.data("resource") ? listItem.data("resource") : listItem.data("document"));
        let documentType = listItem.data("type");   // Para el caso de los documentos de tipo enlace interno

        const currentDocument = documentationPathUtils.getSectionItem(documentId);
        documentType = documentType ? documentType : currentDocument.type;

        if (currentDocument.completed && currentDocument.progressState === 'COMPLETED') {
            return;
        }

        if (currentDocument && !currentDocument.isBlocked && DocumentationUtils.isAutomaticReadingDocument(documentType)) {
            documentationScreenController.manageDocumentViews(currentDocument);

            if (currentDocument.new == null || currentDocument.new) {
                docSocket.emit(SocketEvents.REMOVE_NEW_REQUEST(), JSON.stringify({document_id: currentDocument.id}));
            }

            //Completing the reading of the document (!)
            documentationScreenController.documentationProgress.startRead(currentDocument.id);

            if (['AUDIO', 'VIDEO'].indexOf(documentType) >= 0) {
                if (world.documentation_autoplay) {
                    listItem.find(documentType)[0].play();
                }

            }

            this.currentReadingDocument = currentDocument.id;
        }
    }

    startScrollManagement(startReadingScroll){
        let that = this;
        let reading = false;    // Para controlar cuando un elemento decorativo está en pantalla
        let prevDocCanvas = false;

        let screen = documentationScreenController.screen;
        this.currentReadingDocument = null;

        const documentationContent = $('body');
        const currentFolder = documentationScreenController.getCurrentFolder();
        const documentationDocuments = $('#documentation-documents');
        let documentationFolderHeader = $(screen).find('.documentation-folder-header[data-folder="' + currentFolder.id + '"]')
        const headerHeight = $(documentationFolderHeader).height();

        let sectionHeader =  $(screen).find('.documentation-folder-header[data-folder="' + currentFolder.id  + '"]');

        // Si la cabecera esta visible en la zona de las carpetas de la documentacion dejamos el espacio del header.
        if (sectionHeader.length > 0) {
            $(screen).find('#documentation-folders-table').addClass('is-header-visible');
        } else {
            $(screen).find('#documentation-folders-table').removeClass('is-header-visible');
        }

        documentationContent.data('scroll', 0);

        let firstListItem = $(screen).find(".documentation-advanced-documents-row[data-folder='" + currentFolder.id +"'], .documentation-documents-special-row[data-folder='" + currentFolder.id +"']").first();
        let lastItemRead = null;
        let lastAutoScrollItem = firstListItem.data('document');
        let advancedView = storage.getItem("documentation-advanced-mode") === 'true';

        if(lastAutoScrollItem) {
            if(startReadingScroll)
                this.markAsReadingItem(firstListItem);

            lastItemRead = firstListItem;
        }

        this.updateLastRead = function (lastRead) {lastItemRead = lastRead; lastAutoScrollItem = lastRead.data('document')};

        this.manageItemsScroll = function(e, currentScroll = null, lastScroll = window.scrollY) {
            screen = documentationScreenController.screen;
            documentationScreenController.documentationGoUp.manageGoUpButtonStatus(currentFolder.id);

            if((!e || e.originalEvent) && documentationScreenController.folderModeView === 'advanced'){
                let currentFolder = documentationScreenController.getCurrentFolder();
                let sectionHeader =  $(screen).find('.documentation-folder-header[data-folder="' + currentFolder.id  + '"]');
                let windowMiddle = $('body').height()/2;

                // Seleccionar la mitad superior de la pantalla
                let startDownSearchSpace = $(window).scrollTop();
                let endDownSearchSpace = startDownSearchSpace + windowMiddle;

                // Seleccionar la mitad inferior de la pantalla
                let startUpSearchSpace = $(window).scrollTop() + windowMiddle;
                let endUpSearchSpace = $(window).scrollTop() + $('body').height();

                $(screen).find(".documentation-advanced-documents-row[data-folder='" + currentFolder.id + "'], .documentation-documents-special-row[data-folder='" + currentFolder.id + "']").each(function () {
                    if($(window).scrollTop() > lastScroll){          // Se baja el scroll. Se lee el siguiente documento
                        let elemStart = $(this).position().top;
                        let elemEnd = $(this).position().top + $(this).height();

                        if((elemStart >= startDownSearchSpace && elemStart <= endDownSearchSpace || elemStart < startDownSearchSpace && elemEnd >= endDownSearchSpace) && lastAutoScrollItem !== $(this).data('document')) {
                            lastAutoScrollItem = $(this).data('document');
                            let functionCall = false;
                            if(!prevDocCanvas) {
                                functionCall = that.stopCurrentReadingItem($(this), lastItemRead);
                            }

                            if(!functionCall)
                                that.markAsReadingItem($(this));

                            lastItemRead = $(this);
                            reading = true;
                            prevDocCanvas = false;
                            return false;
                        }
                    } else if($(window).scrollTop() < lastScroll){   // Se sube el scroll. Se lee el documento anterior
                        let elemStart = $(this).position().top;
                        let elemEnd = $(this).position().top + $(this).height();

                        if((elemEnd >= startUpSearchSpace && elemEnd <= endUpSearchSpace || elemEnd > endUpSearchSpace && elemStart <= startUpSearchSpace) && lastAutoScrollItem !== $(this).data('document')) {
                            lastAutoScrollItem = $(this).data('document');
                            let functionCall = false;
                            if(!prevDocCanvas) {
                                functionCall = that.stopCurrentReadingItem($(this), lastItemRead);
                            }

                            if(!functionCall)
                                that.markAsReadingItem($(this));

                            lastItemRead = $(this);
                            reading = true;
                            prevDocCanvas = false;
                            return false;
                        }
                    }
                });

                if(lastItemRead !== null && lastItemRead !== undefined && lastItemRead.length > 0) {
                    // Los elementos canvas no se leen, pero hay que parar de leer los elementos que si se leen si no tienen el foco
                    let end = $(lastItemRead).position().top + $(lastItemRead).height();
                    let start = $(lastItemRead).position().top;

                    if (((endDownSearchSpace - 150) > end || (startUpSearchSpace + 150) < start) && reading) {
                        documentationScreenController.documentationProgress.stopRead(lastItemRead.data('document'));
                        reading = false;
                        prevDocCanvas = true;
                        this.currentReadingDocument = null;
                    }
                }
            }
            documentationContent.data("scroll", $(window).scrollTop());
        }

        documentationContent.off("wheel.manageItemScroll").on("wheel.manageItemScroll", function(e){
            let currentScroll = null; //documentationContent.getNiceScroll()[0];
            let lastScroll = documentationContent.data("scroll");

            that.manageItemsScroll(e, currentScroll, lastScroll);
        });

        $(documentationContent).off('touchmove.manageItemScroll').on('touchmove.manageItemScroll', _.throttle(function(e) {
            let currentScroll = null; //documentationContent.getNiceScroll()[0];
            let lastScroll = documentationContent.data("scroll");

            that.manageItemsScroll(e, currentScroll, lastScroll);
        }, 300));
    }

    stopCurrentReadingItem(listItem, lastItemRead){
        let folder = documentationScreenController.getCurrentFolder();
        let lastDocument = null;
        let documentType = lastItemRead ? lastItemRead.data("type") : null;   // Para el caso de los documentos de tipo enlace interno
        let functionCall = false;
        let that = this;

        if(lastItemRead && folder['documents']){
            lastDocument = folder['documents'][documentationScreenController.getDocumentIndex(lastItemRead.data("document"))];
            if (!lastDocument) {
                // Es posible que el documento sea un enlace interno y no se encuentre dentro de la carpeta
                lastDocument = documentationScreenController.getDocument(lastItemRead.data("document"), false);
            }

            documentType = documentType ? documentType : lastDocument.type;
        }

        if (lastDocument && this.currentReadingDocument && (!listItem || (listItem.data('document') !== lastItemRead.data('document')))){

            if(DocumentationUtils.isAutomaticReadingDocument(documentType)) {

                const isMultimedia = DocumentationUtils.isMultimediaDocument(documentType);
                if (listItem && !isMultimedia) {
                    documentationScreenController.documentationSockets.callbackReadingFunc = () => {
                        this.markAsReadingItem(listItem);
                    };
                }

                documentationScreenController.documentationProgress.stopRead(lastDocument.id);
                this.currentReadingDocument = null;

                if (['AUDIO', 'VIDEO'].indexOf(documentType) >= 0) {
                    pauseMedia(lastItemRead.find(documentType)[0]);
                }
            }
        } else if (lastDocument) {
            if (['AUDIO', 'VIDEO'].indexOf(documentType) >= 0) {
                pauseMedia(lastItemRead.find(documentType)[0]);
            }
        }

        return functionCall;
    }

    markAsReadingItem(listItem){

        let that = this;
        let folder = documentationScreenController.getCurrentFolder();
        let documentId = parseInt(listItem.data("resource") ? listItem.data("resource") : listItem.data("document"));
        let documentType = listItem.data("type");   // Para el caso de los documentos de tipo enlace interno
        let currentDocument = null;
        let screen = documentationScreenController.screen;

        if(folder['documents'] && listItem.length>0) {
            let documentFound = folder['documents'].filter(doc => {
                return doc.id === documentId;
            });

            // Es posible que el documento sea un enlace interno y no se encuentre dentro de la carpeta
            if(!documentFound.length) {
                currentDocument = documentationScreenController.getDocument(documentId, false);
            } else {
                currentDocument = documentFound[0];
            }

            documentType = documentType ? documentType : currentDocument.type;

            if (currentDocument && DocumentationUtils.isAutomaticReadingDocument(documentType)) {

                documentationScreenController.manageDocumentViews(currentDocument);

                if (currentDocument.new == null || currentDocument.new) {
                    docSocket.emit(SocketEvents.REMOVE_NEW_REQUEST(), JSON.stringify({document_id: currentDocument.id}));
                }

                documentationScreenController.documentationProgress.startRead(currentDocument.id);

                if (['AUDIO', 'VIDEO'].indexOf(documentType) >= 0) {
                    if (world.documentation_autoplay) {
                        const docx = listItem.find(documentType) ? listItem.find(documentType)[0] : null;

                        if(docx) {
                            docx.play();
                        }
                    }

                }

                this.currentReadingDocument = currentDocument.id;

            }

            $(screen).find(".hidden-disabled-advanced-document").removeClass("hidden-disabled-advanced-document");
            listItem.find(".disabled-advanced-background-document").addClass("hidden-disabled-advanced-document");
        }
    }
}